let rightAnswerArr: string[] = [
  '간섭',
  '간접',
  '갈등',
  '갈증',
  '감동',
  '감정',
  '강물',
  '강변',
  '건물',
  '걸음',
  '결승',
  '결심',
  '결정',
  '결혼',
  '경찰',
  '경험',
  '균형',
  '금연',
  '긴장',
  '낙엽',
  '남북',
  '남성',
  '냇물',
  '녹음',
  '농담',
  '능력',
  '단골',
  '단점',
  '단풍',
  '달빛',
  '당근',
  '덕분',
  '독립',
  '동물',
  '동작',
  '동전',
  '등록',
  '등산',
  '만약',
  '만일',
  '만족',
  '면적',
  '면접',
  '명단',
  '명절',
  '문장',
  '문학',
  '물건',
  '물속',
  '민속',
  '민족',
  '반성',
  '반죽',
  '받침',
  '발견',
  '발등',
  '발목',
  '발생',
  '발음',
  '발전',
  '발전',
  '밤색',
  '밤중',
  '방면',
  '방문',
  '방문',
  '방식',
  '백성',
  '백인',
  '번역',
  '벌금',
  '범인',
  '변동',
  '병실',
  '본성',
  '본질',
  '볼펜',
  '분량',
  '분석',
  '분필',
  '불만',
  '불안',
  '불편',
  '불평',
  '불행',
  '빗물',
  '산길',
  '산업',
  '산책',
  '살인',
  '삼촌',
  '상금',
  '상점',
  '상품',
  '생물',
  '선물',
  '선장',
  '선택',
  '설명',
  '설문',
  '설탕',
  '성별',
  '성질',
  '성함',
  '속담',
  '손길',
  '손등',
  '손발',
  '손질',
  '송편',
  '술병',
  '술잔',
  '술집',
  '승진',
  '식당',
  '식량',
  '식물',
  '식품',
  '신경',
  '신랑',
  '신발',
  '신청',
  '실감',
  '실망',
  '실장',
  '실정',
  '실천',
  '실험',
  '실현',
  '심장',
  '심정',
  '심판',
  '암컷',
  '압력',
  '앞길',
  '앞문',
  '앨범',
  '약점',
  '약품',
  '역할',
  '연락',
  '연말',
  '연설',
  '연속',
  '연습',
  '연출',
  '연필',
  '연합',
  '옆집',
  '옛날',
  '욕실',
  '욕심',
  '음력',
  '음반',
  '음식',
  '인물',
  '인삼',
  '일반',
  '일손',
  '입력',
  '입맛',
  '입술',
  '입학',
  '작성',
  '작업',
  '작품',
  '잘못',
  '잠옷',
  '장군',
  '장면',
  '장식',
  '전공',
  '전달',
  '전망',
  '전통',
  '절망',
  '절반',
  '절약',
  '접근',
  '접촉',
  '정답',
  '정말',
  '정면',
  '정문',
  '정식',
  '정신',
  '졸업',
  '졸음',
  '종합',
  '죽음',
  '중간',
  '중단',
  '중독',
  '중반',
  '중심',
  '직선',
  '직업',
  '진급',
  '진동',
  '진찰',
  '진출',
  '진통',
  '진행',
  '질문',
  '질병',
  '집단',
  '집안',
  '찬물',
  '찬성',
  '참석',
  '창문',
  '책방',
  '책상',
  '책임',
  '천둥',
  '천장',
  '철학',
  '첫날',
  '촛불',
  '출근',
  '출산',
  '출신',
  '출연',
  '출입',
  '출장',
  '출판',
  '충돌',
  '친절',
  '친정',
  '칠판',
  '큰길',
  '큰일',
  '큰절',
  '탄생',
  '통신',
  '통합',
  '특별',
  '특성',
  '특징',
  '판결',
  '팝송',
  '평균',
  '품질',
  '풍속',
  '풍습',
  '필통',
  '학번',
  '학생',
  '학술',
  '학습',
  '학점',
  '한글',
  '한복',
  '한숨',
  '한식',
  '할인',
  '핵심',
  '햇볕',
  '햇빛',
  '행복',
  '현금',
  '현상',
  '현실',
  '현장',
  '혈액',
  '형님',
  '형식',
  '흑인',
  '흔적',
  '흥분',
];

export { rightAnswerArr };
